<template>
    <div class="slice barometer-hero">
        <div class="slice-content relative text-left">
            <MktShapeTopRight class="barometer-hero__shape" />
            <div class="barometer-hero__wrapper">
                <div class="barometer-hero__content">
                    <MktBreadcrumbs v-if="breadcrumbs" class="barometer-hero__breadcrumbs" :breadcrumbs="breadcrumbs" />
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <h1 class="barometer-hero__title" v-html="title" />
                    <p v-if="subtitle">{{ subtitle }}</p>
                    <NuxtLink v-if="cta" :to="$withLocalePrefix(cta?.url)" external>
                        <VJoyButton variant="main">{{ cta?.label }}</VJoyButton>
                    </NuxtLink>
                </div>
                <div class="barometer-hero__image">
                    <MaltImg v-if="imageUrl" :src="imageUrl" :alt="title" width="660" height="400" sizes="mobile:553px tablet:660px" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {MktBreadcrumbs, MktShapeTopRight, MaltImg} from '#components';
    import {VJoyButton} from '@maltjoy/core-vue';

    type Cta = {label: string; url: string};
    type Breadcrumb = {label: string; url?: string};

    defineProps<{
        title: string;
        subtitle?: string;
        cta?: Cta;
        breadcrumbs?: Breadcrumb[];
        imageUrl?: string;
    }>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .barometer-hero {
        &__shape {
            position: absolute;
            top: 0;
            right: 0;
            width: 100%;
        }

        &__wrapper {
            position: relative;
            text-align: center;

            @include mq.screen_md(min) {
                display: flex;
                align-items: center;
                text-align: left;

                > div {
                    width: 50%;
                    margin-bottom: var(--joy-core-spacing-8);
                }
            }
        }

        &__breadcrumbs {
            margin-bottom: var(--joy-core-spacing-8);
        }

        &__title {
            font-family: var(--joy-font-family-title);
            font-size: var(--joy-font-size-secondary-400);
            line-height: var(--joy-line-height-small);

            @include mq.screen_sm(min) {
                font-size: var(--joy-font-size-secondary-600);
            }

            @include mq.screen_md(min) {
                text-align: left;
                font-size: var(--joy-font-size-secondary-800);
            }

            strong {
                font-size: var(--joy-font-size-primary-400);
                font-weight: var(--joy-font-weight-normal);
                margin-top: var(--joy-core-spacing-6);
                display: block;
                text-transform: uppercase;

                @include mq.screen_md(min) {
                    text-align: left;
                    font-size: var(--joy-font-size-primary-600);
                }
            }
        }

        &__cta {
            margin-top: var(--joy-core-spacing-8);
        }

        &__image {
            display: none;

            img {
                width: 100%;
                object-fit: cover;
            }

            @include mq.screen_md(min) {
                display: block;
                max-height: 100%;
            }
        }
    }
</style>
